import React, { Component } from 'react';
import CargomaticModal from 'components/v2/modal';
import CargomaticTooltip from 'components/v2/Tooltip';
import { withTranslation } from 'react-i18next';

class AdminEditProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
    };
  }

  handleChange(field) {
    return (e) => {
      const value = e.target.value;
      this.setState((prevState) => {
        return {
          ...prevState,
          user: { ...prevState.user, [field]: value },
        };
      });
    };
  }

  renderBody() {
    const { t } = this.props;
    return (
      <>
        <div className="grid grid-cols-4 gap-2">
          <div className="col-span-2 sm:col-span-2">
            <label className="flex mb-2 form-label">
              {t('FIRST_NAME')} *
              <CargomaticTooltip id="first_name" className="ml-2">
                {t('FIRST_NAME_REQUIRED')}!
              </CargomaticTooltip>
            </label>
            <input
              type="text"
              placeholder="John"
              className="w-full mb-4 form-field"
              onChange={this.handleChange('first_name')}
              value={this.state.user.first_name}
            />
          </div>

          <div className="col-span-2 sm:col-span-2">
            <label className="flex mb-2 form-label">
              {t('LAST_NAME')} *
              <CargomaticTooltip id="last_name" className="ml-2">
                {t('LAST_NAME_REQUIRED')}!
              </CargomaticTooltip>
            </label>
            <input
              type="text"
              placeholder="Smith"
              className="w-full mb-4 form-field"
              onChange={this.handleChange('last_name')}
              value={this.state.user.last_name}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-2 sm:col-span-2 ">
            <label className="flex mb-2 form-label">
              {t('EMAIL')} *
              <CargomaticTooltip id="email_id" className="ml-2">
                {t('EMAIL_IS_REQUIRED')}!
              </CargomaticTooltip>
            </label>
            <input
              type="email"
              placeholder="jsmith@cargomatic.com"
              className="w-full mb-4 form-field"
              onChange={this.handleChange('email')}
              value={this.state.user.email}
            />
          </div>
        </div>
      </>
    );
  }

  renderFooter() {
    const { t } = this.props;
    return (
      <div>
        <button
          className="button button-secondary"
          type="button"
          onClick={() => this.hide()}
        >
          {t('CANCEL')}
        </button>
        <button className="button button-green" onClick={() => this.save()}>
          {t('SAVE')}
        </button>
      </div>
    );
  }

  save() {
    this.props.onSave(this.state.user);
  }

  hide() {
    this.props.onHide();
  }
  render() {
    const { t } = this.props;
    return (
      <CargomaticModal
        backdrop="static"
        style={{ top: '20%' }}
        dialogClassName="modal-override-md"
        showCloseButton
        title={t('EDIT_ACCOUNT')}
        show={this.props.show}
        body={this.renderBody()}
        footer={this.renderFooter()}
        onHide={() => this.hide()}
      />
    );
  }
}

export default withTranslation()(AdminEditProfileModal);
